<template>
    <div class="survey-note-view-patient">

        <div class="survey-note-view__section"
             v-if="surveyNote.subjective">
            <label class="font-weight-bold">{{ $i18n.gt('LABEL_SUBJECTIVE') }}</label>
            <div class="survey-note-view__note-text">{{ surveyNote.subjective }}</div>
        </div>

        <div class="survey-note-view__section"
             v-if="surveyNote.objective">
            <label class="font-weight-bold">{{ $i18n.gt('LABEL_OBJECTIVE') }}</label>
            <div class="survey-note-view__note-text">{{ surveyNote.objective }}</div>
        </div>

        <div class="survey-note-view__section"
             v-if="surveyNote.assessment">
            <label class="font-weight-bold">{{ $i18n.gt('LABEL_ASSESSMENT') }}</label>
            <div class="survey-note-view__note-text">{{ surveyNote.assessment }}</div>
        </div>

        <div class="survey-note-view__section"
             v-if="surveyNote.plan_of_care">
            <label class="font-weight-bold">{{ $i18n.gt('LABEL_PLAN_OF_CARE') }}</label>
            <div class="survey-note-view__note-text">{{ surveyNote.plan_of_care }}</div>
        </div>

        <div class="survey-note-view__section"
             v-if="checkedHandouts.length">
            <label class="font-weight-bold">{{ $i18n.gt('LABEL_HANDOUTS') }}</label>
            <div class="survey-note-view__note-text">
                <ul>
                    <li v-for="(handout, i) in checkedHandouts" :key="i">
                        <handout-download-link :handout="handout">
                        </handout-download-link>
                    </li>
                </ul>
            </div>
        </div>

        <div class="survey-note-view__section"
             v-if="surveyNote.cancer_screening_types">
            <label class="font-weight-bold">{{ $i18n.gt('LABEL_SCREENING_DUE') }}</label>
            <div class="survey-note-view__note-text">{{ surveyNote.cancer_screening_types }}</div>
        </div>

    </div>
</template>

<script>
    import * as _ from 'lodash'

    /**
     * Displays details of a SurveyNote in a format appropriate for a Participant
     */
    export default {
        name: 'SurveyNoteViewPatient',
        props: {
            surveyNote: Object
        },
        computed: {
            checkedHandouts () {
                return _.filter(this.surveyNote.handouts, (h) => h.checked)
            }
        }
    }
</script>

<style lang="scss">

    .survey-note-view-patient {
        .survey-note-view__section {
            margin-bottom: 1.25rem;
        }

        .survey-note-view__note-text {
            white-space: pre-line;
            font-weight: normal;
            color:#777;
            li {
                margin-left:30px;
            }
        }
    }
</style>
